
jQuery(function ($) {
  console.log("tab script loaded");

  const interval = setInterval(function () {
    const $tab = $("#tab-tab_cNVPee");

    if ($tab.length) {
      console.log("tab found, clicking");
      $tab.trigger("click");
      clearInterval(interval);
    }
  }, 100);
});


jQuery(function ($) {

  const params = new URLSearchParams(window.location.search);

  if (params.has('cart-open')) {

      const el = document.querySelector('a.m-cart-icon-bubble');
      if (!el) return;

      // Block navigation ONCE
      el.addEventListener(
      'click',
      function (e) {
          e.preventDefault();
      },
      { once: true }
      );

      // Trigger native click (theme listener runs)
      el.click();

      // Clean URL
      params.delete('cart-open');
      const cleanUrl =
      window.location.pathname +
      (params.toString() ? '?' + params.toString() : '');

      window.history.replaceState({}, '', cleanUrl);

  }

  bindIntentControlsOnce()

  jQuery(document).on('click', '.m-tab-header', function () {
    const $tab = $($(this).attr('href'))
    $('.m-tab-header').removeClass('active');
    $(this).addClass('active');

    $('.m-tab-filers').hide();
    $('#' + $(this).data('filters')).show();

    // Reset filters
    $('.m-tab-filer-cloudlist li, .m-tab-filer-list li').removeClass('active');
    initSlick($tab);

  });

  function getActiveValues(selector, attr) {
    return $(selector + '.active')
      .map(function () {
        return $(this).data(attr);
      })
      .get();
  }

  function normalizeArray(value) {
    return (value || '')
      .toString()
      .split(',')
      .map(v => v.trim())
      .filter(Boolean);
  }

  function applyFilters() {

    const activeSpaces        = getActiveValues('.m-tab-filer-cloudlist li[data-space]', 'space');
    const activeSizes         = getActiveValues('.m-tab-filer-list li[data-space-size]', 'space-size');
    const activeProfiles      = getActiveValues('.m-tab-filer-cloudlist li[data-scent-profile]', 'scent-profile');
    const activeFlavors       = getActiveValues('.m-tab-filer-cloudlist li[data-flavor]', 'flavor');
    const activeDiffuserTypes = getActiveValues('.m-tab-filer-cloudlist li[data-diffuser-type]', 'diffuser-type');

    const $activeTab = $('.m-tab-content:visible');

    var workingslides =  $activeTab.find('.product-slider')

    if ($.fn.slick && workingslides.length && workingslides.hasClass('slick-initialized')) {
      workingslides.slick('unslick');
    }

    var memoryslides = $activeTab.find('.default-slider')

    workingslides
    .empty()
    .append(memoryslides.children().clone(true));

    $activeTab.find('.product-slider .mc-product-card').each(function () {

      const $card = $(this); 

      const cardSpaces        = normalizeArray($card.data('scent-by-space'));
      const cardProfiles      = normalizeArray($card.data('scent-profile'));
      const cardFlavors       = normalizeArray($card.data('flavors'));
      const cardDiffuserTypes = normalizeArray($card.data('diffuser-type'));
      const cardSize          = $card.data('space-size');

      let visible = true;

      if (activeSpaces.length) {
        visible = activeSpaces.some(v => cardSpaces.includes(v));
      }

      if (visible && activeSizes.length) {
        visible = activeSizes.includes(cardSize);
      }

      if (visible && activeProfiles.length) {
        visible = activeProfiles.some(v => cardProfiles.includes(v));
      }

      if (visible && activeFlavors.length) {
        visible = activeFlavors.some(v => cardFlavors.includes(v));
      }

      if (visible && activeDiffuserTypes.length) {
        visible = activeDiffuserTypes.some(v => cardDiffuserTypes.includes(v));
      }
      
      if(!visible){
        $card.remove();
      }

    }); 

    const remaining = workingslides.find('.mc-product-card').length;

    if (!remaining) {
      // Optional: show "No results" UI
      workingslides.html('<div class="no-results">No products found</div>');
      return;
    }

    initSlick($activeTab)  
    
  }

  // Generic toggle handler
  let filterTimer;
  $(document).on('click', '.m-tab-filer-cloudlist li, .m-tab-filer-list li', function () {
    
    $('.product-slider').removeClass('slick-ready');
    
    const $this = $(this);
    clearTimeout(filterTimer);
    filterTimer = setTimeout(function () {
      $(".m-tab-filer-cloudlist li, .m-tab-filer-list li").removeClass("active");
      $this.addClass('active');
      applyFilters();
    }, 500);
  });

  $activeTab = $('.m-tab-content.active');
  initSlick($activeTab)  

});

function syncFakeSlider($slider, $tab) {
  const slick = $slider.slick('getSlick');
  if (!slick) return;

  const total = slick.slideCount;
  const visible = slick.options.slidesToShow;
  const maxIndex = total - visible;

  const $bar = $tab.find('.false.slider .fs-fill');

  // Width = visible slides
  const fillWidth = (visible / total) * 100;

  $bar.css({
    width: fillWidth + '%',
    left: 0+'%',
  });

  // Update on slide change
  $slider.off('afterChange.fakebar').on('afterChange.fakebar', function (e, slick, current) {
    const maxTranslate = 100 - fillWidth;
    const translate = maxIndex > 0
      ? (current * ((100 - fillWidth) / maxIndex))
      : 0;

    $bar.css({
      left: `${translate}%`
    });
  }); 
}

 
let resizeTimer;
let fadeInTimer;

$(window).on('resize', function () {
  clearTimeout(resizeTimer);

  resizeTimer = setTimeout(function () {
    $('.m-tab-content.active').each(function () {
      initSlick($(this));
    });
  }, 200); // debounce
});


function initSlick($tab) {

  var $slider = $tab.find('.product-slider');
  $slider.addClass("thisSlider");

  
  // Destroy if exists
  if ($.fn.slick && $slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  
  let attempts = 0;
  const maxAttempts = 20;

  const waitForWidth = setInterval(() => {
    attempts++;

    const width = $slider.outerWidth();
    const CheckWidth = $tab.outerWidth();
    // ✅ REAL readiness check

    //console.log("children:", $slider.children().length);
    const screenWidth = window.innerWidth;
    //console.log(screenWidth);

    function getSlidesToShow(width) {
      if (width >= 1230) return 3;
      if (width >= 996) return 2;
      if (width >= 765) return 1;
      if (width >= 500) return 2;
      return 1;
    }

    const slidesToShow = getSlidesToShow(screenWidth);

    if ($slider.children().length > slidesToShow) {
      clearInterval(waitForWidth);

      $slider.slick({
        slidesToShow,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        adaptiveHeight: false,
        prevArrow: $tab.find('.scc-left-arrow'),
        nextArrow: $tab.find('.scc-right-arrow'),
        responsive: [
          { breakpoint: 1230, settings: { slidesToShow: 2 } },
          { breakpoint: 996,  settings: { slidesToShow: 1 } },
          { breakpoint: 765,  settings: { slidesToShow: 2 } },
          { breakpoint: 500,  settings: { slidesToShow: 1 } }
        ]
      });

      // show slider
  
      syncFakeSlider($slider, $tab);
    }

    clearInterval(fadeInTimer);
    fadeInTimer = setTimeout(() => {
      $slider.addClass('slick-ready');
    }, 500);

    // ❌ fail-safe
    if (attempts >= maxAttempts) {
      clearInterval(waitForWidth);
      console.warn('Slick init aborted: slider never became visible');
    }
  }, 100); // 50ms pulse

  
}
 
if (!customElements.get("m-product-tabs")) {
  class MProductTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        loadMoreBtn: "[data-load-more-product]",
        productsContainer: "[data-products-container]",
        tabContent: [".m-tab-content"],
      };
      this.tabSliders = [];
      this.sliderEnabled = this.dataset.enableSlider === "true";
      this.mobileSliderDisable = this.dataset.mobileDisableSlider === "true";
      this.buttonType = this.dataset.buttonType;
      this.domNodes = queryDomNodes(this.selectors, this);
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.items;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.sliderEnabled) {
        for (let block of this.domNodes.tabContent) {
          this.initSliderByScreenSize(block);
          document.addEventListener("matchMobile", () => {
            this.initSliderByScreenSize(block);
          });
          document.addEventListener("unmatchMobile", () => {
            this.initSliderByScreenSize(block);
          });
        }
      }
      if (!this.sliderEnabled && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;

        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      if (MinimogTheme.config.mqlMobile && this.mobileSliderDisable && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;
        for (let block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }
      document.addEventListener("matchMobile", () => {
        if (MinimogTheme.config.mqlMobile && this.mobileSliderDisable && this.buttonType === "load") {
          this.canLoad = true;
          this.currentPage = 1;
          for (let block of this.domNodes.tabContent) {
            this.initLoadMore(block);
          }
        }
      });
      this.initTabs();
      this.initMobileSelect();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const blockSelectedIsTab = event.target.classList.contains("m-tab-content");
          if (!blockSelectedIsTab) return;
          const dataIndex = event.target && event.target.dataset.index;
          this.tabs.setActiveTab(dataIndex);
        });
      }
    }

    initTabs() {
      this.tabs = new MinimogTheme.Tabs(this, (target) => {
        const tabId = target.getAttribute("href");
        const slider = this.querySelector(tabId + " .swiper-container");
        const controlsContainer = this.querySelector(tabId + " .m-slider-controls");
        // trigger update slider
        slider && slider.swiper && slider.swiper.update();
        const firstItem = slider && (slider.querySelector(".m-image") || slider.querySelector(".m-placeholder-svg"));
        if (firstItem && controlsContainer) {
          const itemHeight = firstItem.clientHeight;
          controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");
        }
      });
    }

    initSliderByScreenSize(sliderContainer) {
      const mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      const slider = sliderContainer.querySelector(".m-mixed-layout__wrapper");
      const controlsContainer = sliderContainer.querySelector(".m-slider-controls");

      if (MinimogTheme.config.mqlMobile && mobileDisableSlider) {
        controlsContainer && controlsContainer.classList.add("m:hidden");
        slider.classList.remove("swiper-container");
        if (slider.swiper) slider.swiper.destroy(false, true);
      } else {
        controlsContainer && controlsContainer.classList.remove("m:hidden");
        setTimeout(() => {
          this.initSlider(sliderContainer);
        });
      }
    }

    initSlider(sliderContainer) {
      const layoutWrapper = sliderContainer.querySelector(".m-product-list");
      const swiper = sliderContainer && sliderContainer.querySelector(".m-mixed-layout__wrapper");
      const controlsContainer = sliderContainer.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength =
        sliderContainer &&
        sliderContainer.querySelector(".swiper-wrapper") &&
        sliderContainer.querySelector(".swiper-wrapper").childElementCount;
      if (parseInt(this.items) >= slideItemsLength) {
        controlsContainer && controlsContainer.classList.add("m:hidden");
        layoutWrapper.classList.add("m-mixed-layout--mobile-grid");
        return;
      }

      swiper && swiper.classList.add("swiper-container");

      let slider = new MinimogLibs.Swiper(swiper, {
        slidesPerView: 1.2,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: this.enableFlashsale ? false : true,
        pagination: this.showPagination
          ? {
              el: sliderContainer.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          992: {
            slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init: function () {
            setTimeout(() => {
              // Calculate controls position
              const firstItem =
                sliderContainer.querySelector(".m-image") || sliderContainer.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton.classList.remove("m:hidden");
                nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => slider.slideNext());
      }
    }

    initMobileSelect() {
      this.select = this.querySelector("[data-tab-select]");
      this.select.addEventListener("change", () => {
        this.tabs.setActiveTab(parseInt(this.select.value));
        const slider = this.tabs && this.tabs.currentTab && this.tabs.currentTab.querySelector(".swiper-container");
        const controlsContainer =
          this.tabs && this.tabs.currentTab && this.tabs.currentTab.querySelector(".m-slider-controls");
        const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
        const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
        slider && slider.swiper && slider.swiper.update();
        const firstItem = slider && slider.querySelector(".m-image");
        if (firstItem && controlsContainer) {
          const itemHeight = firstItem.clientHeight;
          controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

          prevButton.classList.remove("m:hidden");
          nextButton.classList.remove("m:hidden");
        }
      });
    }

    initLoadMore(wrapper) {
      addEventDelegate({
        context: wrapper,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore(wrapper);
        },
      });
    }

    handleLoadMore(wrapper) {
      const loadBtn = wrapper.querySelector(this.selectors.loadMoreBtn);
      const productsContainer = wrapper.querySelector(this.selectors.productsContainer);

      let currentPage = wrapper.dataset.page;
      currentPage = parseInt(currentPage);
      const totalPages = wrapper.dataset.totalPages;
      this.toggleLoading(loadBtn, true);

      const url = wrapper.dataset.url;
      const dataUrl = `${url}?page=${currentPage + 1}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        currentPage++;
        wrapper.dataset.page = currentPage;
        this.toggleLoading(loadBtn, false);
        const dom = generateDomFromString(html);
        const tabId = wrapper.getAttribute("id");
        const products = dom.querySelector(`#${tabId} ${this.selectors.productsContainer}`);

        if (products) {
          Array.from(products.childNodes).forEach((product) => productsContainer.appendChild(product));
        }

        if (currentPage >= parseInt(totalPages)) loadBtn && loadBtn.remove();
      });

      // Remove button focus
      loadBtn.blur();
    }

    toggleLoading(loadBtn, status) {
      if (!loadBtn) return;
      if (status) {
        loadBtn.classList.add("m-spinner-loading");
      } else {
        loadBtn.classList.remove("m-spinner-loading");
      }
    }
  }
  customElements.define("m-product-tabs", MProductTabs);
}

function bindIntentControlsOnce() {
   
  $(document).off('click', '.intent');
  console.log('Intent controls bound ONCE');

  /* =========================
     VARIANT SELECT
  ========================= */

  // hover variant image
  $(document).on('mouseenter', '[data-variant-id]', function () {

      const $btn = $(this);
      const $card = $btn.closest('.simple-product-card');

      const image_url = $btn.attr('data-image');
      const $img = $card.find('.card-image img');

      if (!$img.attr('data-original-src')) {
          $img.attr('data-original-src', $img.attr('src'));
      }

      if (image_url) {
          $img.attr({
              src: image_url,
              srcset: image_url
          });
      }
 
  });

  // restore original image
  $(document).on('mouseleave', '[data-variant-id]', function () {

      const $btn = $(this);
      const $card = $btn.closest('.simple-product-card');

      const $img = $card.find('.card-image img');
      const original = $img.attr('data-original-src');

      if (original) {
          $img.attr({
              src: original,
              srcset: original
          });
      }

  });


  $(document).on('click', '[data-variant-id]', function () {
    const $btn = $(this);
    const $card = $btn.closest('.simple-product-card');

    const $vid = $btn.closest('.simple-product-video');
    
    const variantId = $btn.data('variant-id');
    const price = $btn.data('price');
    const image_url = $btn.attr('data-image'); // safer than .data()

    console.log("click to cardPrice", price, "image_url", image_url);

    // Update price
    if (price) {
        $card.find('.card-price').html(price);
        $vid.find('.card-price').html(price);
    }

    // Update image
    if (image_url) {
        $card.find('.card-image img').attr({
            src: image_url,
            srcset: image_url
        });
        $card.find('.card-image img').attr('data-original-src', image_url);
    }

    

    const $variantsContainer = $btn.closest('.card-variants');
    const productId = $variantsContainer
      .attr('id')
      ?.replace('card-variant-', '')
      ?.replace('card-variantant-', '');

    // Toggle active state
    $btn
      .closest('.variant-group')
      .find('[data-variant-id]')
      .removeClass('is-active')
      .attr('aria-pressed', 'false');

    $btn
      .addClass('is-active')
      .attr('aria-pressed', 'true');

    // Update Buy Now button
    $('#buy-button-' + productId).attr('data-variant-id', variantId);
  });

  /* =========================
     QTY BUTTONS
  ========================= */
  $(document).on('click', '.qty-btn', function () {
    const $btn = $(this);
    const productId = $btn.data('id');
    const $input = $('#qty-input-' + productId);

    let qty = parseInt($input.val(), 10) || 1;

    qty += $btn.data('action') === 'increase' ? 1 : -1;
    if (qty < 1) qty = 1;

    $input.val(qty);
  });

  /* =========================
     BUY NOW
  ========================= */

  console.log("loading by now")
  $(document).on('click', '.buy-now-btn', function (e) {
    e.preventDefault();

    console.log("product tabs")
    const $btn = $(this);
    const productId = $btn.data('id');
    const variantId = $btn.data('variant-id');
    const $qtyInput = $('#qty-input-' + productId);


     console.log($btn,productId, variantId, $qtyInput)

    let quantity = parseInt($qtyInput.val(), 10) || 1;
    if (!variantId) return;

    $btn.prop('disabled', true).addClass('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(() => {
      document.dispatchEvent(
        new CustomEvent('cart:refresh', { detail: { open: true } })
      );

      const url = new URL(window.location.href);
      url.searchParams.set('cart-open', '1');
      window.location.href = url.toString();
    })
    .finally(() => {
      $btn.prop('disabled', false).removeClass('loading');
    });
  });
}
